import React, { useRef, useState } from 'react';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import { usePopup } from 'core/modules/Popup/PopupProvider';
import { useAdjustPosition } from './hooks/useAdjustPosition';

import config from './configs';

import './Popup.scss';

function Popup({
  className = '', options = {}, onCloseCallback, onCollapseCallback, onExpandCallback,
  children, collapsedContent, isExpandedByDefault = true,
}) {
  const { popup, closePopup } = usePopup();
  const [isExpanded, setIsExpanded] = useState(isExpandedByDefault);

  const popupRef = useRef();

  useAdjustPosition(popupRef);

  const combinedOptions = {
    ...config.options, // 1. Base (default) config for the popup
    ...options, // 2. Current Popup config
    ...popup.options, // 3. Config from the component that triggers popup
  };

  const { shouldShowCloseButton } = combinedOptions;

  const onClosePopup = () => {
    onCloseCallback?.();
    closePopup();
  };

  const onExpandPopup = () => {
    onExpandCallback?.();
    setIsExpanded(true);
  };

  const onCollapsePopup = () => {
    onCollapseCallback?.();
    setIsExpanded(false);
  };

  const onCloseClick = () => (collapsedContent ? onCollapsePopup() : onClosePopup());

  return (
    <div className={`mn_popup ${className}`} ref={popupRef}>
      {isExpanded ?
        <div className="mn_content mn_expanded">
          {shouldShowCloseButton
            && <button className="mn_closePopup" onClick={onCloseClick} aria-label="close popup" />
          }
          {children}
        </div> :
        <button className="mn_content mn_collapsed" onClick={onExpandPopup}>
          {collapsedContent}
        </button>
      }
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><Popup {...props} /></ComponentErrorBoundary>;
